<!-- Task Priority Picker - Urgent/Normal -->
<eva-tag
  *ngIf="isUrgent"
  [preset]="urgentTagPreset"
  size="small"
  [rounded]="true"
  tabindex="0"
  role="button"
  aria-label="Urgente : repasser en normale"
  (click)="toggle()"
  evaTooltip="Urgente : cliquer pour repasser en normale"
></eva-tag>
<eva-button
  *ngIf="!isUrgent"
  icon="heroFlag"
  variant="text"
  size="small"
  severity="secondary"
  (onClick)="toggle()"
  ariaLabel="Définir comme urgent"
  tooltip="Marquer comme urgente"
></eva-button>
